<template>
	<div class="cards">
		<div class="vx-row">
			<div class="vx-col w-full mb-base">
				<h3>Data per dag</h3>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="order-amount-days"
					class="vs-con-loading__container"
					:icon="['fas', 'shopping-cart']"
					icon-right
					:statistic="orderAmount.days.data.now"
					statisticTitle="Bestellingen vandaag"
					:chartData="orderAmount.days.data.series"
					:showTooltipX="true"
					color="warning" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="revenue-days"
					class="vs-con-loading__container"
					:icon="['fas', 'euro-sign']"
					icon-right
					:statistic="revenue.days.data.now"
					statisticTitle="Omzet vandaag"
					:chartData="revenue.days.data.series"
					:showTooltipX="true"
					color="success" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="average-days"
					class="vs-con-loading__container"
					:icon="['fas', 'coins']"
					icon-right
					:statistic="average.days.data.now"
					statisticTitle="Gem. bestel waarde vandaag"
					:chartData="average.days.data.series"
					:showTooltipX="true"
					color="primary" />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full mb-base">
				<h3>Data per week</h3>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="order-amount-weeks"
					class="vs-con-loading__container"
					:icon="['fas', 'shopping-cart']"
					icon-right
					:statistic="orderAmount.weeks.data.now"
					statisticTitle="Bestellingen deze week"
					:chartData="orderAmount.weeks.data.series"
					:showTooltipX="true"
					color="warning" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="revenue-weeks"
					class="vs-con-loading__container"
					:icon="['fas', 'euro-sign']"
					icon-right
					:statistic="revenue.weeks.data.now"
					statisticTitle="Omzet deze week"
					:chartData="revenue.weeks.data.series"
					:showTooltipX="true"
					color="success" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="average-weeks"
					class="vs-con-loading__container"
					:icon="['fas', 'coins']"
					icon-right
					:statistic="average.weeks.data.now"
					statisticTitle="Gem. bestel waarde deze week"
					:chartData="average.weeks.data.series"
					:showTooltipX="true"
					color="primary" />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full mb-base">
				<h3>Data per maand</h3>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="order-amount-months"
					class="vs-con-loading__container"
					:icon="['fas', 'shopping-cart']"
					icon-right
					:statistic="orderAmount.months.data.now"
					statisticTitle="Bestellingen deze maand"
					:chartData="orderAmount.months.data.series"
					:showTooltipX="true"
					color="warning" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="revenue-months"
					class="vs-con-loading__container"
					:icon="['fas', 'euro-sign']"
					icon-right
					:statistic="revenue.months.data.now"
					statisticTitle="Omzet deze maand"
					:chartData="revenue.months.data.series"
					:showTooltipX="true"
					color="success" />
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
				<statistics-card-line
					id="average-months"
					class="vs-con-loading__container"
					:icon="['fas', 'coins']"
					icon-right
					:statistic="average.months.data.now"
					statisticTitle="Gem. bestel waarde deze maand"
					:chartData="average.months.data.series"
					:showTooltipX="true"
					color="primary" />

			</div>
		</div>
	</div>
</template>

<script>

import StatisticsCardLine from '../components/statistics-cards/StatisticsCardLine';

export default {
	name: 'dashboard',
	components: {StatisticsCardLine},
	data() {
		return {
			orderAmount: {
				days: {
					loaded: false,
					containerId: 'order-amount-days',
					data: {
						now: 34,
						series: [{
							name: 'Bestellingen',
							data: [24, 42, 11, 32, 53, 23, 33]
						}],
					}
				},
				weeks: {
					loaded: false,
					containerId: 'order-amount-weeks',
					data: {
						now: 218,
						series: [{
							name: 'Bestellingen',
							data: [214, 432, 121, 322, 563, 273, 233]
						}],
					}
				},
				months: {
					loaded: false,
					containerId: 'order-amount-months',
					data: {
						now: 1201,
						series: [{
							name: 'Bestellingen',
							data: [1234, 1402, 960, 984, 1135, 1042, 1098]
						}],
					}
				}
			},
			revenue: {
				days: {
					loaded: false,
					containerId: 'revenue-days',
					data: {
						now: 34,
						series: [{
							name: 'Omzet',
							data: [24, 42, 11, 32, 53, 23, 33]
						}],
					}
				},
				weeks: {
					loaded: false,
					containerId: 'revenue-weeks',

					data: {
						now: 218,
						series: [{
							name: 'Omzet',
							data: [
								214, 432, 121, 322, 563, 273, 233
							]
						}],
					}
				},
				months: {
					loaded: false,

					containerId: 'revenue-months',
					data: {
						now: 1201,
						series: [{
							name: 'Omzet',
							data: [1234, 1402, 960, 984, 1135, 1042, 1098]
						}],
					}
				},
			},
			average: {
				days: {
					loaded: false,
					containerId: 'average-days',
					data: {
						now: 34,
						series: [{
							name: 'Gem. bestel waarde',
							data: [24, 42, 11, 32, 53, 23, 33]
						}],
					}
				},
				weeks: {
					loaded: false,
					containerId: 'average-weeks',
					data: {
						now: 218,
						series: [{
							name: 'Gem. bestel waarde',
							data: [214, 432, 121, 322, 563, 273, 233]
						}],
					}
				},
				months: {
					loaded: false,
					containerId: 'average-months',
					data: {
						now: 1201,
						series: [{
							name: 'Gem. bestel waarde',
							data: [1234, 1402, 960, 984, 1135, 1042, 1098]
						}],
					}
				}
			}
		}
	},
	mounted() {
		this.startLoading(this.orderAmount.days.containerId);
		this.startLoading(this.orderAmount.weeks.containerId);
		this.startLoading(this.orderAmount.months.containerId);
		this.startLoading(this.revenue.days.containerId);
		this.startLoading(this.revenue.weeks.containerId);
		this.startLoading(this.revenue.months.containerId);
		this.startLoading(this.average.days.containerId);
		this.startLoading(this.average.weeks.containerId);
		this.startLoading(this.average.months.containerId);

		this.$store.dispatch('salesValues/initAmountDays').then(res => {
			this.orderAmount.days.data = {...this.$store.state.salesValues.salesValues.amount.days};
			this.stopLoading(this.orderAmount.days.containerId);
		});

		this.$store.dispatch('salesValues/initAmountWeeks').then(res => {
			this.orderAmount.weeks.data = {...this.$store.state.salesValues.salesValues.amount.weeks};
			this.stopLoading(this.orderAmount.weeks.containerId);
		});

		this.$store.dispatch('salesValues/initAmountMonths').then(res => {
			this.orderAmount.months.data = {...this.$store.state.salesValues.salesValues.amount.months};
			this.stopLoading(this.orderAmount.months.containerId);
		});

		this.$store.dispatch('salesValues/initRevenueDays').then(res => {
			this.revenue.days.data = {...this.$store.state.salesValues.salesValues.revenue.days};
			this.stopLoading(this.revenue.days.containerId);
		});

		this.$store.dispatch('salesValues/initRevenueWeeks').then(res => {
			this.revenue.weeks.data = {...this.$store.state.salesValues.salesValues.revenue.weeks};
			this.stopLoading(this.revenue.weeks.containerId);
		});

		this.$store.dispatch('salesValues/initRevenueMonths').then(res => {
			this.revenue.months.data = {...this.$store.state.salesValues.salesValues.revenue.months};
			this.stopLoading(this.revenue.months.containerId);
		});

		this.$store.dispatch('salesValues/initAverageDays').then(res => {
			this.average.days.data = {...this.$store.state.salesValues.salesValues.average.days};
			this.stopLoading(this.average.days.containerId);
		});

		this.$store.dispatch('salesValues/initAverageWeeks').then(res => {
			this.average.weeks.data = {...this.$store.state.salesValues.salesValues.average.weeks};
			this.stopLoading(this.average.weeks.containerId);
		});

		this.$store.dispatch('salesValues/initAverageMonths').then(res => {
			this.average.months.data = {...this.$store.state.salesValues.salesValues.average.months};
			this.stopLoading(this.average.months.containerId);
		});
	},
	methods: {
		startLoading(containerId) {
			this.$vs.loading({
				container: '#' + containerId,
				scale: 0.6
			});
		},
		stopLoading(containerId) {
			setTimeout(() => {
				this.$vs.loading.close('#' + containerId + ' > .con-vs-loading')
			}, 300)
		}
	}
}
</script>
